/* eslint-disable react/no-danger */
import React from 'react';

import NdsThemeProviderPurple from '@ntuctech/devex-tangram/Theme/NdsThemeProviderPurple';

import ErrorPageContent from '../ErrorPageContent';
import { ERROR_TITLE_DEFAULT, ERROR_BODY_NOSCRIPT } from '../../../constants';

export const NoScriptContent = () => {
  const noScriptPageTitle = `${ERROR_TITLE_DEFAULT} - Linkpass`; // TODO: change to Linkpass after 1 Apr

  return (
    <NdsThemeProviderPurple>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          [data-testid='pageContent'],
          [data-testid='pageLoader'] {
            display: none;
          }
          `,
        }}
      />
      <title>{noScriptPageTitle}</title>
      <ErrorPageContent
        data-testid="pageContentNoScript"
        title={ERROR_TITLE_DEFAULT}
        body={ERROR_BODY_NOSCRIPT}
      />
    </NdsThemeProviderPurple>
  );
};

const NoScript = () => (
  <noscript
    style={{
      width: '100%',
    }}
  >
    <NoScriptContent />
  </noscript>
);

export default NoScript;
